<template>
    <div class="main-register">
        <div class="register-content">
            <div class="register-menus">
                <ul>
                    <li :class="activeName == 1?'active':''" @click="handleClick(1)">版权登记介绍</li>
                    <li :class="activeName == 2?'active':''" @click="handleClick(2)">线下一日达办理</li>
                    <li :class="activeName == 3?'active':''" @click="handleClick(3)">线上立即办理</li>
                </ul>
            </div>
            <article1 v-if="activeName == 1"></article1>
            <article2 v-if="activeName == 2"></article2>
        </div>
    </div>
</template>
<script>
    import { getCopyrightIntroduce, getOffLineDelivery } from '@/api/business';
    import article1 from '@/views/article/article1.vue'
    import article2 from '@/views/article/article2.vue'
    export default {
        name:'service',
        components:{
            article1,article2
        },
        data () {
            return {
                tabPosition:'left',
                pageCurrent:1,
                innerHeight:window.innerHeight,
                activeTab:'register',
                introduceText:'',
                offlineContent:'',
                activeName:1
            }
        },
        mounted() {
           this.init()
        },
        methods: {
            init(){
                // getCopyrightIntroduce().then(res=>{
                //     if(res.code==200){
                //         this.introduceText = res.result?.introduceContent;
                //     }   
                    
                // }).catch(e=>{
                //     console.log("netowrk error",e)
                // })
            },
            handleClick(key){
                if(key == 3){
                    window.open('http://home.bqshfw.com');
                    return;
                }
                this.activeName = key;
            },
            offLinetext(){
                getOffLineDelivery().then(res=>{
                    if(res.code==200){
                        this.offlineContent = res.result.offlineContent;
                    }  
                })
            },
            handleTabChange(val){
                if(val==='online'){
                    window.open('http://home.bqshfw.com');
                    return false;
                }
                 if(val === 'complete'){
                    this.offLinetext()
                }

            }
        },
        computed: {

        },
        watch: {

        }
    }
</script>

<style lang="less" scoped>

.main-register{
    // background-color: #e4e4e4;
    // box-sizing: border-box;
    // padding: 0.54rem 0.74rem;
    // background-image: url('../../assets/images/active-bg.png');
    // background-repeat: no-repeat;
    // background-size: 100% 100%;
    // min-height: 100vh;
    background-color: #fff;
    margin-top: 68px;
    
    .register-content{
        width: 1200px;
        margin: 0 auto;

        .register-menus{
            height: 50px;
            font-size: 22px;
            border-bottom: 2px solid #EFEFEF;
            padding-top: 50px;
            ul{
                display: flex;
                justify-content: center;
            }
            ul li{
                padding: 0 30px;
                color: #999;
                position: relative;
                cursor: pointer;
                height: 50px;
            }
            ul li.active{
                color: #333 !important;
                font-weight: 600;
            }
            ul li.active::after{
                content: "";
                position: absolute;
                left: 0;
                bottom: -2px;
                height: 3px;
                width: 100%;
                background-color: #333;
            }
        }
    }
}
 
</style>
<style>
    img{
        max-width:100% ! important;
    }
</style>